
// stocai_frontend/src/components/HomePage/components/Celebration/CelebrationFutureSelf.jsx
import React, { useEffect, useState } from "react";
import CelebrationScreen from "../Celebration/CelebrationScreen";
import FutureIdentityCard from "../../../HomePage/components/widgets/Identity/FutureYou/FutureIdentityCard";
import { progressService } from "../../../../services/progressService";
import bgFutureImg from "../../../../assets/bg_future.png";

const CelebrationFutureSelf = ({
  userId,
  subsectionId,               // module 7 id (for status)
  futureIdentitySubsectionId,  // future identity widget
  currentIdentitySubsectionId, // current identity widget
  onNextStep,
}) => {
  const [futureData, setFutureData] = useState(null);

  useEffect(() => {
    async function loadFutureDetails() {
      try {
        const [futureIdentityRec, currentIdentityRec] = await Promise.all([
          progressService.getUserProgress(userId, futureIdentitySubsectionId),
          progressService.getUserProgress(userId, currentIdentitySubsectionId),
        ]);

        const futurePayload =
          futureIdentityRec?.data?.payload || futureIdentityRec?.data || {};
        const currentPayload =
          currentIdentityRec?.data?.payload || currentIdentityRec?.data || {};

        setFutureData({
          userName: currentPayload.userName || "User",
          profileImageUrl: currentPayload.profileImage || "",
          designation:
            futurePayload.designation ||
            futurePayload.futureTitle ||
            currentPayload.currentTitle ||
            "Your Role",
          salary:
            futurePayload.salary ||
            currentPayload.salary ||
            "",
          timeline: futurePayload.timeline || "",
          location:
            futurePayload.location ||
            currentPayload.location ||
            "",
          knownFor: Array.isArray(futurePayload.knownFor)
            ? futurePayload.knownFor
            : [],
          futureVoiceNote:
            currentPayload.futureVoiceNote ||
            futurePayload.futureVoiceNote ||
            "",
        });
      } catch (err) {
        console.error("Error loading future details:", err);
      }
    }

    if (userId && futureIdentitySubsectionId && currentIdentitySubsectionId) {
      loadFutureDetails();
    }
  }, [userId, futureIdentitySubsectionId, currentIdentitySubsectionId]);

  if (!futureData) return <div className="p-10">Loading...</div>;

  return (
    <CelebrationScreen
      title="Your Future Self is now clearer than ever!"
      subtitle="You’ve defined who you must become, what you will be known for, and even heard a message from your future self."
      theme="meeting_personality"
      onNext={undefined}
      hideBack={true}
      hideGlobalCTA={true}
    >
      {/* outer wrapper with bg_future, like ComparisonScreen */}
      <div
        className="relative w-full max-w-4xl flex flex-col items-center"
        style={{
          backgroundImage: `url(${bgFutureImg})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          backgroundSize: "758.0339px 874.6545px",
        }}
      >
        {/* white card on top of the background */}
        <div className="relative z-[1] w-full max-w-xl bg-transparent px-6 flex flex-col items-center gap-4">
          <FutureIdentityCard
            futureData={futureData}
            userName={futureData.userName}
            profileImage={futureData.profileImageUrl}
            currentInput={""}
            coreValues={[]}
            showCoreValues={false}
          />

          <button
            type="button"
            onClick={onNextStep}
            className="
              mt-4
              flex items-center justify-between
              w-[255px] h-[56px]
              rounded-[16.2px]
              bg-[#000000]
              px-[16.2px] py-[17.82px]
              text-white text-[16px]
              font-[Gotham] font-medium
            "
          >
            <span className="font-medium">Reveal the Future</span>
            <span
              className="
                flex items-center justify-center
                w-[20px] h-[20px]
                rounded-full
                bg-white text-black
              "
            >
              <svg width={10} height={10} viewBox="0 0 20 20" fill="none">
                <path
                  d="M8 5l4 5-4 5"
                  stroke="#151A1F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </button>
        </div>
      </div>
    </CelebrationScreen>
  );
};

export default CelebrationFutureSelf;
